// Copyright 2022-2025 - Hewlett Packard Enterprise Company
import { useState, useContext } from 'react';
import { Box, Anchor } from 'grommet';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { getGroup } from '../../actions/Api';
import GroupDisabledModal from './GroupDisabledModal';
import { AuthContext } from '../../providers/AuthProvider';

export default function GroupDetailsLink({
  groupId,
  name,
  tenantAcid,
  handleError,
}) {
  const [disabledOpen, setDisabledOpen] = useState(false);
  const [disabledGroup, setDisabledGroup] = useState();
  const history = useHistory();
  const { updateTenantAcid } = useContext(AuthContext);
  const groupDetailUrlPrefix = '/groupDetail/';

  const openDisabledModal = groupName => {
    setDisabledGroup(groupName);
    setDisabledOpen(true);
  };

  const updateTenantAndRedirect = (tenantAcid, route) => {
    tenantAcid && updateTenantAcid(tenantAcid);
    history.push(route);
  };

  const onClickGroupLink = async (grpId, groupName, handleErr) => {
    let group = null;
    if (grpId) {
      const req = getGroup(grpId, tenantAcid);
      const resp = await req.catch(error => {
        if (error?.response?.status === 404) openDisabledModal(groupName);
        else handleErr(error);
      });
      if (resp) {
        group = resp.data;
      }
    }
    if (group) {
      updateTenantAndRedirect(tenantAcid, `${groupDetailUrlPrefix}${grpId}`);
    }
  };

  return (
    <Box>
      <Anchor
        label={name}
        onClick={async () => {
          onClickGroupLink(groupId, name, handleError);
        }}
      />
      {disabledOpen && (
        <GroupDisabledModal
          groupName={disabledGroup}
          onClose={() => {
            setDisabledOpen(false);
          }}
        />
      )}
    </Box>
  );
}

GroupDetailsLink.propTypes = {
  groupId: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  tenantAcid: PropTypes.string,
  handleError: PropTypes.func.isRequired,
};
